import {AfterViewInit, ContentChild, Directive, ElementRef, Input, Renderer2} from '@angular/core';
import {AbstractControl, NG_VALIDATORS, NgModel, ValidationErrors, Validator} from "@angular/forms";
import {_cclValidate, _CclValidateRuleGroup} from "../../validates-util";

@Directive({
    selector: '[cclValidateRule]',
    providers: [{provide: NG_VALIDATORS, useExisting: ValidateRuleDirective, multi: true}]
})
export class ValidateRuleDirective implements Validator, AfterViewInit {
    @Input()
    cclValidateRule = {};
    @Input()
    messageBox;

    @ContentChild(NgModel, {static: false})
    ngModel: NgModel;

    private cclItemWrap: any;
    private cclLabelWrap: any;

    constructor(private elementRef: ElementRef, private renderer2: Renderer2) {
    }

    ngAfterViewInit(): void {
        this.cclItemWrap = closest(this.elementRef.nativeElement, 'item-wrap');
        if (this.cclItemWrap) {
            this.cclLabelWrap = this.cclItemWrap.parentNode.querySelector('.label-wrap');
            if (!this.messageBox) {
                this.messageBox = this.cclItemWrap.querySelector('.validate-msg');
            }
            this.updateRequired();
        }
    }

    private updateRequired() {
        if (this.cclLabelWrap && this.cclValidateRule) {
            if (checkRequired(this.cclValidateRule)) {
                this.renderer2.addClass(this.cclLabelWrap, 'required');
            } else {
                this.renderer2.removeClass(this.cclLabelWrap, 'required');
            }
        }

        function checkRequired(rule) {
            if (typeof rule.required !== 'undefined') {
                return rule.required;
            }
            if (rule.ruleGroup && _CclValidateRuleGroup[rule.ruleGroup] && typeof _CclValidateRuleGroup[rule.ruleGroup].required !== 'undefined') {
                return _CclValidateRuleGroup[rule.ruleGroup].required;
            }
        }
    }

    private updateTouched() {
        // å½ngModel touched ä¹åï¼è®¾ç½®classä½¿å¾å¯ä»¥åç¬æ¾ç¤ºæä¸ªç»ä»¶çæ ¡éªä¿¡æ¯
        if (this.ngModel && this.messageBox) {
            if (this.ngModel.dirty || this.ngModel.touched) {
                this.renderer2.addClass(this.messageBox, 'ng-touched');
            } else {
                this.renderer2.removeClass(this.messageBox, 'ng-touched');
            }
        }
    }

    private updateMsg(state) {
        if (this.messageBox) {
            if (state) {
                this.messageBox.innerText = state.msg;
            } else {
                this.messageBox.innerText = '';
            }
        }
    }

    validate(control: AbstractControl): ValidationErrors | null {
        const state = _cclValidate(this.cclValidateRule, control);

        this.updateTouched();
        this.updateRequired();
        this.updateMsg(state);

        if (state) {
            return {
                [state.key]: true
            }
        }
    }
}

function closest(el: HTMLElement, className) {
    if (el && className) {
        let node: any = el;
        let idx = 0;
        do {
            if (idx > 5) {
                return;
            }
            if (node && node.classList && node.classList.contains(className)) {
                return node;
            }
            idx += 1;
        } while ((node = node.parentNode));
    }
}
